/** P0: DashboardHeader, StatusToggle, CompletionBar, Switcher, PlanTab, AdsTab — ko/en/vi/ru */

const header = {
  backAria: ['뒤로', 'Back', 'Quay lại', 'Назад'],
  businessFallback: ['업체', 'Business', 'Doanh nghiệp', 'Бизнес'],
  unreadInquiriesTitle: ['읽지 않은 문의', 'Unread inquiries', 'Tin nhắn chưa đọc', 'Непрочитанные запросы'],
  exitHomeAria: ['유저 홈으로', 'Go to user home', 'Về trang chủ người dùng', 'На главную пользователя'],
  notificationsAria: ['알림', 'Notifications', 'Thông báo', 'Уведомления'],
  searchAria: ['검색', 'Search', 'Tìm kiếm', 'Поиск'],
};

/** 사업자등록증 인증 마크 (대시보드·소비자 상호명 옆 공통) */
const businessVerified = {
  verifiedBadgeAria: [
    '사업자 인증',
    'Business verified',
    'Doanh nghiệp đã xác minh',
    'Бизнес подтверждён',
  ],
};

const statusToggle = {
  changeFail: ['상태 변경 실패', 'Could not update status', 'Không đổi được trạng thái', 'Не удалось изменить статус'],
  pausedToast: ['준비중으로 전환했어요', 'Switched to preparing', 'Đã chuyển sang đang chuẩn bị', 'Переключено на «Скоро открытие»'],
  resumeToast: ['영업을 재개했어요', 'Business is open again', 'Đã mở lại cửa hàng', 'Работа возобновлена'],
  limited: ['노출 대기/제한', 'Pending / limited', 'Chờ / hạn chế', 'Ожидание / ограничение'],
  paused: ['준비중', 'Preparing', 'Đang chuẩn bị', 'Скоро открытие'],
  operating: ['영업중', 'Open', 'Đang mở', 'Открыто'],
  readOnlyHint: [
    '심사 중이거나 제재된 업체는 토글할 수 없어요.',
    'Under review or restricted businesses cannot be toggled.',
    'Doanh nghiệp đang duyệt hoặc bị hạn chế không thể đổi.',
    'Бизнес на проверке или с ограничениями нельзя переключать.',
  ],
  processing: ['처리 중…', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  pauseAction: ['준비중', 'Preparing', 'Đang chuẩn bị', 'Скоро открытие'],
  resumeAction: ['영업 재개', 'Resume', 'Mở lại', 'Возобновить'],
  hiringOperating: ['채용중', 'Hiring', 'Đang tuyển', 'Идёт набор'],
  hiringPaused: ['일시중단', 'Paused', 'Tạm dừng', 'Приостановлено'],
  hiringPauseAction: ['일시중단', 'Pause', 'Tạm dừng', 'Пауза'],
  hiringResumeAction: ['채용 재개', 'Resume hiring', 'Tiếp tục tuyển', 'Возобновить набор'],
  hiringPausedToast: [
    '채용을 일시중단했어요',
    'Hiring paused',
    'Đã tạm dừng tuyển dụng',
    'Набор приостановлен',
  ],
  hiringResumeToast: [
    '채용을 재개했어요',
    'Hiring is open again',
    'Đã mở lại tuyển dụng',
    'Набор возобновлён',
  ],
};

const completion = {
  titleNamed: ['{name} · 프로필 완성도', '{name} · Profile completion', '{name} · Độ hoàn thiện hồ sơ', '{name} · Заполненность профиля'],
  title: ['프로필 완성도', 'Profile completion', 'Độ hoàn thiện hồ sơ', 'Заполненность профиля'],
  tipLocation: [
    '위치를 등록하면 거리순 검색에 노출돼요 (+15%)',
    'Add a location to appear in distance search (+15%)',
    'Thêm vị trí để hiện trong tìm theo khoảng cách (+15%)',
    'Добавьте локацию для поиска по расстоянию (+15%)',
  ],
  tipIntro: [
    '업체 소개를 작성하면 검색 노출이 높아져요 (+15%)',
    'Write a business intro to improve search visibility (+15%)',
    'Viết giới thiệu để tăng hiển thị tìm kiếm (+15%)',
    'Добавьте описание — выше в поиске (+15%)',
  ],
  tipHours: [
    '영업시간을 등록하면 영업중 필터에 노출돼요 (+10%)',
    'Add hours to appear in the “open now” filter (+10%)',
    'Thêm giờ mở cửa để hiện trong bộ lọc đang mở (+10%)',
    'Укажите часы — фильтр «открыто сейчас» (+10%)',
  ],
  tipDone: [
    '프로필이 잘 완성됐어요!',
    'Your profile looks complete!',
    'Hồ sơ đã khá hoàn thiện!',
    'Профиль хорошо заполнен!',
  ],
};

const switcher = {
  currentAria: ['현재 업체', 'Current business', 'Doanh nghiệp hiện tại', 'Текущий бизнес'],
  myBusinessesAria: ['내 업체', 'My businesses', 'Doanh nghiệp của tôi', 'Мои бизнесы'],
  addNewAria: ['새 업체 등록', 'Register new business', 'Đăng doanh nghiệp mới', 'Зарегистрировать бизнес'],
  sheetTitle: ['내 업체', 'My businesses', 'Doanh nghiệp của tôi', 'Мои бизнесы'],
  closeAria: ['닫기', 'Close', 'Đóng', 'Закрыть'],
  addNew: ['+ 새 업체 등록', '+ Register new business', '+ Đăng doanh nghiệp mới', '+ Новый бизнес'],
  close: ['닫기', 'Close', 'Đóng', 'Закрыть'],
};

const plan = {
  slotRail: ['홈 레일 슬롯', 'Home rail slot', 'Slot thanh home', 'Слот домашней полосы'],
  slotMapPin: ['지도 핀 부스트', 'Map pin boost', 'Tăng ghim bản đồ', 'Буст пина на карте'],
  slotInfeed: ['피드 인피드 슬롯', 'In-feed slot', 'Slot trong feed', 'Слот в ленте'],
  slotDirectory: ['디렉터리 상단', 'Directory top', 'Đầu danh mục', 'Верх каталога'],
  upgradeNote: [
    '업체 대시보드 플랜 업그레이드 문의 ({packageKey})',
    'Business dashboard plan upgrade inquiry ({packageKey})',
    'Yêu cầu nâng cấp gói dashboard ({packageKey})',
    'Запрос апгрейда плана в кабинете ({packageKey})',
  ],
  upgradeSuccess: [
    '업그레이드 문의가 접수되었습니다. 어드민이 연락드립니다.',
    'Upgrade request submitted. An admin will contact you.',
    'Đã gửi yêu cầu nâng cấp. Admin sẽ liên hệ.',
    'Запрос отправлен. Админ свяжется с вами.',
  ],
  inquireFail: ['문의 접수에 실패했습니다.', 'Could not submit inquiry.', 'Không gửi được yêu cầu.', 'Не удалось отправить запрос.'],
  inquireError: ['문의 실패', 'Inquiry failed', 'Yêu cầu thất bại', 'Ошибка запроса'],
  inquiryNote: [
    '업체 대시보드 플랜 업그레이드 문의 (현재: {label})',
    'Business dashboard plan upgrade inquiry (current: {label})',
    'Yêu cầu nâng cấp gói dashboard (hiện tại: {label})',
    'Запрос апгрейда плана (сейчас: {label})',
  ],
  inquirySuccess: [
    '문의가 접수되었습니다. 운영팀이 연락드립니다.',
    'Inquiry submitted. Our team will contact you.',
    'Đã gửi yêu cầu. Đội vận hành sẽ liên hệ.',
    'Запрос принят. Команда свяжется с вами.',
  ],
  loading: ['플랜 정보 불러오는 중…', 'Loading plan…', 'Đang tải gói…', 'Загрузка плана…'],
  currentLabel: ['현재 플랜', 'Current plan', 'Gói hiện tại', 'Текущий план'],
  boostExpires: ['부스트 만료: {date}', 'Boost ends: {date}', 'Boost hết: {date}', 'Буст до: {date}'],
  trialLeft: ['무료 체험 {n}일 남음', '{n} days left on free trial', 'Còn {n} ngày dùng thử', 'Осталось {n} дн. пробного периода'],
  trialEnded: [
    '무료 체험 기간이 종료되었습니다',
    'Free trial has ended',
    'Thời gian dùng thử đã kết thúc',
    'Пробный период закончился',
  ],
  bmMonthly: ['월정액형', 'Monthly subscription', 'Thuê bao tháng', 'Месячная подписка'],
  bmCommission: ['수수료형', 'Commission-based', 'Theo hoa hồng', 'Комиссионная'],
  // TODO: 확인 필요 - "카테고리 BM" 업계 약어 번역
  categoryBmHint: [
    '카테고리 BM: {bm} · 구독은 아래 플랜에서 관리해요',
    'Category BM: {bm} · Manage subscription in the plans below',
    'BM danh mục: {bm} · Quản lý đăng ký ở các gói bên dưới',
    'BM категории: {bm} · Подписка управляется в планах ниже',
  ],
  refPrice: [
    '광고 패키지 참고가 월 {price} (USD)',
    'Ad package reference: {price}/mo (USD)',
    'Giá tham khảo gói QC: {price}/tháng (USD)',
    'Ориентир пакета: {price}/мес (USD)',
  ],
  submitting: ['접수 중…', 'Submitting…', 'Đang gửi…', 'Отправка…'],
  upgradeCta: ['업그레이드 문의하기', 'Request upgrade', 'Yêu cầu nâng cấp', 'Запросить апгрейд'],
  manualPayment: [
    '온라인 결제는 준비 중입니다. 구독은 보유 광고 크레딧에서 즉시 차감됩니다.',
    'Online card payment is coming soon. Subscriptions debit your ad credit balance immediately.',
    'Thanh toán thẻ online sắp có. Đăng ký trừ ngay từ số dư tín dụng quảng cáo.',
    'Онлайн-оплата картой скоро. Подписка сразу списывается с рекламных кредитов.',
  ],
  compareTitle: ['광고 패키지 비교', 'Compare ad packages', 'So sánh gói quảng cáo', 'Сравнение пакетов'],
  packageTag: ['광고 패키지', 'Ad package', 'Gói quảng cáo', 'Рекламный пакет'],
  packageNameLocal: ['Local', 'Local', 'Local', 'Local'],
  packageNameGrowth: ['Growth', 'Growth', 'Growth', 'Growth'],
  packageNameSpotlight: ['Spotlight', 'Spotlight', 'Spotlight', 'Spotlight'],
  packageNameEnterprise: ['Enterprise', 'Enterprise', 'Enterprise', 'Enterprise'],
  pricePerMonth: ['{price} / 월', '{price} / mo', '{price} / tháng', '{price} / мес'],
  packageInquire: ['패키지 문의', 'Ask about package', 'Hỏi về gói', 'Спросить о пакете'],
  subTitle: ['카탈로그 구독 플랜', 'Catalog subscription plan', 'Gói đăng ký danh mục', 'Тарифный план каталога'],
  subHint: [
    '광고 패키지와 별개예요. 등록 가능 상품 수·사진 수 등 카탈로그 용량과, 매물/인재정보 등 일부 화면의 우선노출 혜택을 드려요. 보유 크레딧에서 즉시 차감됩니다.',
    'Separate from ad packages. Increases catalog capacity (listings, photos) and gives priority ranking in some screens like properties and talent search. Charged instantly from your credit balance.',
    'Khác với gói quảng cáo. Tăng dung lượng danh mục (số sản phẩm, ảnh) và ưu tiên hiển thị ở một số màn hình như bất động sản, tìm nhân tài. Trừ ngay từ số dư tín dụng.',
    'Отдельно от рекламных пакетов. Увеличивает объём каталога (товары, фото) и даёт приоритет в некоторых разделах — недвижимость, поиск кандидатов. Списывается сразу с баланса кредитов.',
  ],
  subBalance: ['보유 크레딧', 'Your credit', 'Tín dụng hiện có', 'Ваш баланс'],
  subCreditsPerMonth: ['{price} 크레딧 / 30일', '{price} credits / 30 days', '{price} tín dụng / 30 ngày', '{price} кредитов / 30 дней'],
  subSubscribeCta: ['구독하기', 'Subscribe', 'Đăng ký', 'Подписаться'],
  subRenewCta: ['갱신하기', 'Renew', 'Gia hạn', 'Продлить'],
  subActiveBadge: ['구독중', 'Subscribed', 'Đang đăng ký', 'Подписка активна'],
  subActiveUntil: ['{date}까지 유효', 'Active until {date}', 'Có hiệu lực đến {date}', 'Действует до {date}'],
  subSubmitting: ['처리 중…', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  subSuccess: ['구독이 시작(갱신)되었어요.', 'Subscription started/renewed.', 'Đã bắt đầu/gia hạn đăng ký.', 'Подписка активирована/продлена.'],
  subFail: ['구독 처리에 실패했어요.', 'Could not process subscription.', 'Không xử lý được đăng ký.', 'Не удалось оформить подписку.'],
  subInsufficientCredit: [
    '광고 크레딧이 부족해요. 지갑 탭에서 충전해 주세요.',
    'Not enough ad credit. Please top up in the Wallet tab.',
    'Không đủ tín dụng quảng cáo. Vui lòng nạp thêm ở tab Ví.',
    'Недостаточно рекламных кредитов. Пополните баланс во вкладке «Кошелёк».',
  ],
};

/** MyBusinessList / BusinessSwitcher BusinessListCard strings */
const bizCard = {
  businessFallback: ['업체', 'Business', 'Doanh nghiệp', 'Бизнес'],
  categoryUnset: ['카테고리 미설정', 'Category not set', 'Chưa đặt danh mục', 'Категория не задана'],
  categoryOther: ['기타', 'Other', 'Khác', 'Другое'],
  paymentFailed: ['결제 실패 — 확인 필요', 'Payment failed — check', 'Thanh toán lỗi — kiểm tra', 'Ошибка оплаты — проверьте'],
  expiresInDays: ['{n}일 후 만료', 'Expires in {n} days', 'Hết hạn sau {n} ngày', 'Истекает через {n} дн.'],
  ctaPaymentUpdate: ['결제 업데이트', 'Update payment', 'Cập nhật thanh toán', 'Обновить оплату'],
  ctaExtend: ['연장하기', 'Extend', 'Gia hạn', 'Продлить'],
  ctaEnableAutopay: ['자동결제 켜기', 'Enable auto-pay', 'Bật tự thanh toán', 'Включить автооплату'],
  ctaUpgrade: ['업그레이드', 'Upgrade', 'Nâng cấp', 'Апгрейд'],
  ctaManage: ['관리하기', 'Manage', 'Quản lý', 'Управлять'],
  msgPaymentFailed: ['결제가 실패했어요', 'Payment failed', 'Thanh toán thất bại', 'Оплата не прошла'],
  msgExpiresSoon: ['{n}일 후 만료 예정', 'Expires in {n} days', 'Hết hạn sau {n} ngày', 'Истекает через {n} дн.'],
  msgAutopayOff: ['자동결제가 꺼져있어요', 'Auto-pay is off', 'Tự thanh toán đang tắt', 'Автооплата выключена'],
  msgFreePlan: ['무료 플랜 이용중', 'On free plan', 'Đang dùng gói miễn phí', 'На бесплатном плане'],
};

const ads = {
  statusActive: ['진행중', 'Active', 'Đang chạy', 'Активна'],
  statusPaused: ['일시정지', 'Paused', 'Tạm dừng', 'Пауза'],
  statusCompleted: ['완료', 'Completed', 'Hoàn tất', 'Завершена'],
  statusChangeFail: [
    '상태 변경에 실패했습니다.',
    'Could not update status.',
    'Không đổi được trạng thái.',
    'Не удалось изменить статус.',
  ],
  requestNote: [
    '업체 대시보드에서 신규 캠페인 신청',
    'New campaign request from business dashboard',
    'Đăng ký chiến dịch mới từ dashboard',
    'Заявка на кампанию из кабинета бизнеса',
  ],
  requestSuccess: [
    '캠페인 신청이 접수되었습니다. 어드민 검토 후 연락드립니다.',
    'Campaign request submitted. An admin will review and contact you.',
    'Đã gửi đăng ký chiến dịch. Admin sẽ duyệt và liên hệ.',
    'Заявка принята. Админ проверит и свяжется.',
  ],
  requestFail: ['신청에 실패했습니다.', 'Request failed.', 'Đăng ký thất bại.', 'Заявка не отправлена.'],
  requestError: ['신청 실패', 'Request failed', 'Đăng ký thất bại', 'Ошибка заявки'],
  loading: ['캠페인 불러오는 중…', 'Loading campaigns…', 'Đang tải chiến dịch…', 'Загрузка кампаний…'],
  loadFail: [
    '캠페인 목록을 불러오지 못했습니다.',
    'Could not load campaigns.',
    'Không tải được danh sách chiến dịch.',
    'Не удалось загрузить кампании.',
  ],
  retry: ['다시 시도', 'Retry', 'Thử lại', 'Повторить'],
  requesting: ['신청 중…', 'Submitting…', 'Đang gửi…', 'Отправка…'],
  requestNew: ['신규 캠페인 신청', 'Request new campaign', 'Đăng ký chiến dịch mới', 'Новая кампания'],
  empty: [
    '진행 중인 캠페인이 없습니다. 신규 신청을 이용해 주세요.',
    'No active campaigns. Request a new one.',
    'Không có chiến dịch. Hãy đăng ký mới.',
    'Нет активных кампаний. Создайте заявку.',
  ],
  campaignFallback: ['캠페인', 'Campaign', 'Chiến dịch', 'Кампания'],
  expiringWarn: [
    '만료 48시간 이내 — 연장을 검토해 주세요.',
    'Expires within 48 hours — consider extending.',
    'Hết hạn trong 48 giờ — cân nhắc gia hạn.',
    'Истекает в течение 48 ч — подумайте о продлении.',
  ],
  pause: ['일시정지', 'Pause', 'Tạm dừng', 'Пауза'],
  resume: ['재개', 'Resume', 'Tiếp tục', 'Возобновить'],
  topSlotTitle: ['카테고리 상단 슬롯', 'Category top slot', 'Slot đầu danh mục', 'Верхний слот категории'],
  topSlotHint: [
    '카테고리 목록 최상단(최대 3곳)에 노출돼요. 결제 즉시 바로 활성화됩니다.',
    'Shows at the very top of the category list (up to 3 spots). Activates immediately after payment.',
    'Hiện ở đầu danh sách danh mục (tối đa 3 vị trí). Kích hoạt ngay sau khi thanh toán.',
    'Показывается в самом верху списка категории (до 3 мест). Активируется сразу после оплаты.',
  ],
  topSlotBalance: ['보유 크레딧', 'Your credit', 'Tín dụng hiện có', 'Ваш баланс'],
  topSlotDurationLabel: ['노출 기간', 'Duration', 'Thời gian hiển thị', 'Длительность'],
  topSlotDays: ['{n}일', '{n} days', '{n} ngày', '{n} дн.'],
  topSlotCost: ['총 {cost} 크레딧', 'Total {cost} credits', 'Tổng {cost} tín dụng', 'Всего {cost} кредитов'],
  topSlotBuy: ['지금 구매', 'Buy now', 'Mua ngay', 'Купить сейчас'],
  topSlotBuying: ['처리 중…', 'Processing…', 'Đang xử lý…', 'Обработка…'],
  topSlotSuccess: [
    '상단 슬롯이 활성화됐어요.',
    'Top slot activated.',
    'Đã kích hoạt slot đầu trang.',
    'Верхний слот активирован.',
  ],
  topSlotInsufficientCredit: [
    '크레딧이 부족해요. 지갑에서 충전해 주세요.',
    'Not enough credit. Please top up your wallet.',
    'Không đủ tín dụng. Vui lòng nạp thêm.',
    'Недостаточно кредитов. Пополните баланс.',
  ],
  topSlotFail: ['구매에 실패했습니다.', 'Purchase failed.', 'Mua không thành công.', 'Покупка не удалась.'],
  cpmTitle: ['홈 피드 CPM 캠페인', 'Home feed CPM campaign', 'Chiến dịch CPM trên trang chủ', 'CPM-кампания в ленте'],
  cpmHint: [
    '노출 1,000회당 {rate} 크레딧이 자동 차감돼요. 최소 예산 {min} 크레딧.',
    '{rate} credits are charged automatically per 1,000 impressions. Minimum budget: {min} credits.',
    'Tự động trừ {rate} tín dụng mỗi 1.000 lượt hiển thị. Ngân sách tối thiểu {min} tín dụng.',
    'Автоматически списывается {rate} кредитов за 1000 показов. Минимальный бюджет {min} кредитов.',
  ],
  cpmEstImpressions: [
    '예상 노출 약 {n}회',
    '~{n} estimated impressions',
    'Ước tính khoảng {n} lượt hiển thị',
    'Примерно {n} показов',
  ],
  placementNeedSelect: [
    '노출할 화면을 하나 이상 골라 주세요.',
    'Select at least one screen.',
    'Hãy chọn ít nhất một màn hình.',
    'Выберите хотя бы один экран.',
  ],
  placementPerScreenBudget: [
    '화면당 예산',
    'Budget per screen',
    'Ngân sách mỗi màn',
    'Бюджет на экран',
  ],
  placementTotalCost: [
    '화면당 {each} × {n}곳 = 총 {total} 크레딧',
    '{each} per screen × {n} = {total} credits total',
    '{each}/màn × {n} chỗ = tổng {total} tín dụng',
    '{each} за экран × {n} = всего {total} кредитов',
  ],
  cpmSuccessMulti: [
    '{n}개 화면에 캠페인을 시작했어요.',
    'Started campaigns on {n} screens.',
    'Đã bắt đầu chiến dịch trên {n} màn hình.',
    'Кампании запущены на {n} экранах.',
  ],
  cpmPartialFail: [
    '{ok}곳은 시작됐고 {fail}곳은 실패했어요. 크레딧이 부족하거나 오류가 났을 수 있어요.',
    '{ok} started, {fail} failed. Credit may be insufficient or an error occurred.',
    '{ok} đã chạy, {fail} thất bại. Có thể thiếu tín dụng hoặc lỗi.',
    '{ok} запущено, {fail} с ошибкой. Возможно, не хватило кредитов.',
  ],
  cpmBuy: ['캠페인 시작', 'Start campaign', 'Bắt đầu chiến dịch', 'Запустить кампанию'],
  cpmSuccess: [
    'CPM 캠페인이 시작됐어요.',
    'CPM campaign started.',
    'Đã bắt đầu chiến dịch CPM.',
    'CPM-кампания запущена.',
  ],
  cpmFail: ['캠페인 시작에 실패했습니다.', 'Could not start campaign.', 'Không bắt đầu được chiến dịch.', 'Не удалось запустить кампанию.'],
  cpmMinBudget: [
    '최소 예산은 {n} 크레딧이에요.',
    'Minimum budget is {n} credits.',
    'Ngân sách tối thiểu là {n} tín dụng.',
    'Минимальный бюджет — {n} кредитов.',
  ],
  cpcTitle: ['검색 상단 CPC 캠페인', 'Search top CPC campaign', 'Chiến dịch CPC đầu tìm kiếm', 'CPC-кампания вверху поиска'],
  cpcHint: [
    '클릭 1회당 {rate} 크레딧이 자동 차감돼요. 최소 예산 {min} 크레딧.',
    '{rate} credits are charged automatically per click. Minimum budget: {min} credits.',
    'Tự động trừ {rate} tín dụng mỗi lượt nhấp. Ngân sách tối thiểu {min} tín dụng.',
    'Автоматически списывается {rate} кредитов за клик. Минимальный бюджет {min} кредитов.',
  ],
  cpcEstClicks: [
    '예상 클릭 약 {n}회',
    '~{n} estimated clicks',
    'Ước tính khoảng {n} lượt nhấp',
    'Примерно {n} кликов',
  ],
  cpcBuy: ['캠페인 시작', 'Start campaign', 'Bắt đầu chiến dịch', 'Запустить кампанию'],
  cpcSuccess: [
    'CPC 캠페인이 시작됐어요.',
    'CPC campaign started.',
    'Đã bắt đầu chiến dịch CPC.',
    'CPC-кампания запущена.',
  ],
  cpcFail: ['캠페인 시작에 실패했습니다.', 'Could not start campaign.', 'Không bắt đầu được chiến dịch.', 'Не удалось запустить кампанию.'],
  cpcMinBudget: [
    '최소 예산은 {n} 크레딧이에요.',
    'Minimum budget is {n} credits.',
    'Ngân sách tối thiểu là {n} tín dụng.',
    'Минимальный бюджет — {n} кредитов.',
  ],
  placementTitle: ['화면 노출 CPM 캠페인', 'Screen placement CPM campaign', 'Chiến dịch CPM theo màn hình', 'CPM-кампания по разделам'],
  placementHint: [
    '아래 화면을 누르면 미리보기와 설명이 바뀝니다. 손님 앱에서 광고가 실제로 붙는 위치예요. 노출 1,000회당 크레딧이 차감됩니다.',
    'Tap a screen below to see the preview and where the ad actually appears in the customer app. Credits are charged per 1,000 impressions.',
    'Chạm màn hình bên dưới để xem trước và vị trí thật trên app khách. Trừ tín dụng mỗi 1.000 lượt hiển thị.',
    'Нажмите экран ниже — превью и место показа в приложении клиента. Списание за 1000 показов.',
  ],
  previewSearchTop: [
    '검색 결과 상단에 이렇게 노출돼요',
    'Shows at the top of search results, like this',
    'Hiển thị ở đầu kết quả tìm kiếm như thế này',
    'Показывается вверху результатов поиска, вот так',
  ],
  previewCategoryTop: [
    '카테고리 목록 맨 위에 이렇게 노출돼요',
    'Shows at the very top of the category list, like this',
    'Hiển thị ở đầu danh sách danh mục như thế này',
    'Показывается в самом верху списка категории, вот так',
  ],
  previewFeed: [
    '{screen} 화면 피드에 이렇게 노출돼요',
    'Shows in the {screen} feed, like this',
    'Hiển thị trong feed {screen} như thế này',
    'Показывается в ленте раздела «{screen}», вот так',
  ],
  previewHomeFeed: [
    '밍고 홈의 중고거래 목록에서 매물 3개마다 한 줄로 들어갑니다. 글 커뮤니티 홈이 아닙니다.',
    'Goes into the used-goods list on Mingo Home, one row every 3 listings. Not the community post feed.',
    'Vào danh sách đồ cũ trên trang chủ Mingo, một hàng mỗi 3 tin. Không phải feed cộng đồng.',
    'В ленте объявлений на главной Mingo — одна строка каждые 3 товара. Это не лента сообщества.',
  ],
  previewTabHome: ['홈', 'Home', 'Trang chủ', 'Главная'],
  previewTabLife: ['생활', 'Life', 'Đời sống', 'Жизнь'],
  previewTabChat: ['채팅', 'Chat', 'Trò chuyện', 'Чат'],
  previewTabCommunity: ['커뮤니티', 'Community', 'Cộng đồng', 'Сообщество'],
  previewTabMore: ['더보기', 'More', 'Thêm', 'Ещё'],
  previewTitleSearch: ['검색', 'Search', 'Tìm kiếm', 'Поиск'],
  previewTitleCategory: ['카테고리', 'Category', 'Danh mục', 'Категория'],
  packagesTitle: ['광고 패키지 (월 단위 묶음)', 'Ad packages (monthly bundles)', 'Gói quảng cáo (theo tháng)', 'Рекламные пакеты (помесячно)'],
  packagesHint: [
    '여러 슬롯을 한 번에 쓰는 월 패키지예요. 문의 후 운영팀이 열어 드려요. 화면별 CPM/CPC·상단슬롯은 위에서 크레딧으로 바로 집행할 수 있어요.',
    'Monthly bundles that cover several slots. Requested packages are activated by our team. Per-screen CPM/CPC and top slots above can be purchased instantly with credits.',
    'Gói tháng gồm nhiều slot. Gói yêu cầu do đội vận hành kích hoạt. CPM/CPC và slot đầu danh mục ở trên có thể mua ngay bằng tín dụng.',
    'Месячные пакеты на несколько слотов. Заявки активирует команда. CPM/CPC и верхние слоты выше можно купить сразу за кредиты.',
  ],
  adsOnlyHint: [
    '광고 집행은 이 탭에서만 하세요. 구독·요금제(카탈로그 용량)는 플랜 탭입니다.',
    'Run all ads here. Catalog subscription plans live in the Plan tab.',
    'Chạy mọi quảng cáo ở tab này. Gói đăng ký danh mục ở tab Gói.',
    'Вся реклама — на этой вкладке. Подписка каталога — во вкладке «План».',
  ],
};

const placementScreen = {
  chat: ['채팅 목록', 'Chat list', 'Danh sách chat', 'Список чатов'],
  community: ['커뮤니티 글', 'Community posts', 'Bài cộng đồng', 'Посты сообщества'],
  group: ['모임 목록', 'Groups list', 'Danh sách nhóm', 'Список групп'],
  profile: ['마이페이지', 'My page', 'Trang của tôi', 'Моя страница'],
  business_dashboard: ['업체 대시보드 홈', 'Business dashboard home', 'Trang chủ dashboard', 'Главная кабинета'],
  local_listing: ['지역 업체 목록', 'Local business list', 'Danh sách cửa hàng', 'Список местных бизнесов'],
  personal_list: ['찜·내거래·알림', 'Saved, my trades, alerts', 'Đã lưu, giao dịch, thông báo', 'Избранное, сделки, уведомления'],
  service_menu: ['전체 서비스 메뉴', 'All-services menu', 'Menu tất cả dịch vụ', 'Меню всех сервисов'],
  experience_villa: ['체험·풀빌라 목록', 'Experiences & villas lists', 'Danh sách trải nghiệm & villa', 'Списки впечатлений и вилл'],
  jobs: ['구인구직 목록', 'Jobs board', 'Bảng tin việc', 'Доска вакансий'],
  trade: ['중고거래 목록', 'Used-goods list', 'Danh sách đồ cũ', 'Список объявлений'],
  news: ['지역 소식 목록', 'Local news list', 'Danh sách tin địa phương', 'Лента местных новостей'],
};

const placementWhere = {
  chat: [
    '손님 앱 채팅 목록에서 대화 4개마다 작은 광고 한 줄이 들어갑니다. 채팅방 안(대화 화면)에는 안 나갑니다.',
    'In the customer chat list: a compact ad row every 4 conversations. Not inside a chat room.',
    'Trong danh sách chat của khách: một hàng nhỏ mỗi 4 cuộc trò chuyện. Không hiện trong phòng chat.',
    'В списке чатов клиента: компактная строка каждые 4 диалога. Не внутри переписки.',
  ],
  community: [
    '커뮤니티 글 피드에서 글 6개마다 광고 카드가 끼어듭니다.',
    'In the community post feed: an ad card every 6 posts.',
    'Trong feed bài cộng đồng: một thẻ quảng cáo mỗi 6 bài.',
    'В ленте сообщества: карточка каждые 6 постов.',
  ],
  group: [
    '모임 찾기 목록에서 모임 4개마다 광고가 끼어듭니다. 모임 상세에는 안 나갑니다.',
    'In the groups list: an ad every 4 groups. Not on a group detail page.',
    'Trong danh sách nhóm: một quảng cáo mỗi 4 nhóm. Không hiện trang chi tiết nhóm.',
    'В списке групп: объявление каждые 4 группы. Не на странице группы.',
  ],
  profile: [
    '마이페이지(아이콘 메뉴 아래)와 다른 사람 프로필에 가로 배너로 나갑니다.',
    'A horizontal banner on My page (under the icon menu) and on other people’s profiles.',
    'Banner ngang trên Trang của tôi (dưới menu icon) và hồ sơ người khác.',
    'Горизонтальный баннер на «Моей странице» (под иконками) и в чужих профилях.',
  ],
  business_dashboard: [
    '다른 업체가 보는 대시보드 홈, 오늘 현황 아래에 가로 배너로 나갑니다. 손님 홈이 아닙니다.',
    'A horizontal banner on other owners’ dashboard home, under Today. Not the customer Home.',
    'Banner ngang trên trang chủ dashboard chủ khác, dưới mục Hôm nay. Không phải trang chủ khách.',
    'Баннер на главной кабинета других владельцев, под «Сегодня». Это не главная клиента.',
  ],
  local_listing: [
    '병원·식당·호텔 같은 지역 업체 목록에서 업체 3개마다 한 줄로 들어갑니다.',
    'In local lists (hospitals, restaurants, hotels…): one row every 3 businesses.',
    'Trong danh sách địa phương (bệnh viện, quán, khách sạn…): một hàng mỗi 3 mục.',
    'В локальных списках (клиники, кафе, отели…): строка каждые 3 заведения.',
  ],
  personal_list: [
    '찜 목록, 내 거래, 알림 목록 사이에 들어갑니다.',
    'Between items in Saved, My trades, and Notifications.',
    'Chen giữa mục trong Đã lưu, Giao dịch của tôi và Thông báo.',
    'Между пунктами в Избранном, «Моих сделках» и уведомлениях.',
  ],
  service_menu: [
    '전체 서비스 메뉴 화면에서 아이콘 그리드 아래에 가로 배너로 나갑니다.',
    'A horizontal banner on the all-services menu, under the icon grid.',
    'Banner ngang trên menu tất cả dịch vụ, dưới lưới icon.',
    'Баннер в меню всех сервисов, под сеткой иконок.',
  ],
  experience_villa: [
    '체험 목록과 풀빌라 목록 카드 사이에 들어갑니다. 예약 허브에서 들어가는 그 두 화면입니다. 상품 상세에는 안 나갑니다.',
    'Between cards on the Experiences list and the Pool villa list (from the booking hub). Not on detail pages.',
    'Chen giữa thẻ ở danh sách Trải nghiệm và Pool villa (từ hub đặt chỗ). Không hiện trang chi tiết.',
    'Между карточками в списках впечатлений и вилл (из хаба бронирования). Не на детальных страницах.',
  ],
  jobs: [
    '구인구직 게시판 목록에서 공고 6개마다 한 줄로 들어갑니다. 공고 상세에는 안 나갑니다.',
    'On the jobs board: one row every 6 posts. Not on a job detail page.',
    'Trên bảng tin việc: một hàng mỗi 6 tin. Không hiện trang chi tiết.',
    'На доске вакансий: строка каждые 6 объявлений. Не на странице вакансии.',
  ],
  trade: [
    '중고거래 목록에서 매물 6개마다 한 줄로 들어갑니다. 격자 칸이 아니라 상품과 같은 세로 목록입니다.',
    'On the used-goods list: one full-width row every 6 listings. Not a grid tile — same vertical list as products.',
    'Trên danh sách đồ cũ: một hàng ngang mỗi 6 tin. Không ô lưới — cùng danh sách dọc với sản phẩm.',
    'В списке объявлений: полная строка каждые 6 товаров. Не плитка сетки — тот же вертикальный список.',
  ],
  news: [
    '지역 소식 전체 목록에서 기사 5개마다 한 줄로 들어갑니다. 홈 미리보기 3개에는 안 들어갑니다. 나라는 손님이 있는 지역 기준으로 바뀝니다.',
    'On the full local-news list: one row every 5 articles. Not in the 3-item Home preview. The country follows the customer’s location.',
    'Trên danh sách tin địa phương đầy đủ: một hàng mỗi 5 bài. Không trong 3 tin xem trước ở trang chủ. Quốc gia theo nơi khách đang ở.',
    'В полном списке местных новостей: строка каждые 5 статей. Не в 3 превью на главной. Страна — по месту клиента.',
  ],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return {
    dashboard: {
      header: pick(header, langIndex),
      statusToggle: pick(statusToggle, langIndex),
      completion: pick(completion, langIndex),
      switcher: pick(switcher, langIndex),
      plan: pick(plan, langIndex),
      ads: {
        ...pick(ads, langIndex),
        placementScreen: pick(placementScreen, langIndex),
        placementWhere: pick(placementWhere, langIndex),
      },
      bizCard: pick(bizCard, langIndex),
    },
    business: pick(businessVerified, langIndex),
  };
}

export const phaseP0DashKo = buildLang(0);
export const phaseP0DashEn = buildLang(1);
export const phaseP0DashVi = buildLang(2);
export const phaseP0DashRu = buildLang(3);
